import axios from 'axios';
import {
  GET_ALL_EXPLORE_PROVIDERS_WITH_PAGINATION,
  GET_ALL_PROVIDERS_BY_USER_WITH_PAGINATION,
  GET_ALL_PROVIDERS_WITH_PAGINATION,
  GET_PRIVATE_PROVIDERS_BY_USER_WITH_PAGINATION,
  GET_PROVIDERS_WITH_PAGINATION,
} from '../constants';
import { getFirebaseIdToken } from '../utils';

const paginationRequestCall = async (
  pageKey: number,
  pageSize: number,
  searchQuery: string,
  url: string,
  providerType: string = 'ALL'
) => {
  try {
    const accessToken = await getFirebaseIdToken();
    const { data } = await axios.get(url, {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${accessToken}`,
      },
      params: {
        pageKey,
        pageSize,
        searchQuery,
        providerType,
      },
    });
    if (data.isSuccess) {
      const { providers, count, isSuccess } = data;
      return { providers, count, isSuccess };
    }

    return { providers: [], count: 0, isSuccess: false };
  } catch (error) {
    console.log('something went wrong, couldnt fetch the provider list,', error);
    return { providers: [], count: 0, isSuccess: false };
  }
};

export const getPublicProvidersWithPagination = async (
  pageKey: number,
  pageSize: number,
  searchQuery: string = ''
) => {
  try {
    const dataObj = await paginationRequestCall(
      pageKey,
      pageSize,
      searchQuery,
      GET_PROVIDERS_WITH_PAGINATION
    );
    if (dataObj.isSuccess) {
      return dataObj;
    }
  } catch (error) {
    console.log('something went wrong, couldnt fetch the provider list,', error);
  }
};

export const getPrivateProvidersByUserWithPagination = async (
  pageKey: number,
  pageSize: number,
  searchQuery: string = ''
) => {
  try {
    const dataObj = await paginationRequestCall(
      pageKey,
      pageSize,
      searchQuery,
      GET_PRIVATE_PROVIDERS_BY_USER_WITH_PAGINATION
    );
    if (dataObj.isSuccess) {
      return dataObj;
    }
  } catch (error) {
    console.log('something went erong, couldnt fetch the provider list,', error);
  }
};

export const getAllUserProvidersWithPagination = async (
  pageKey: number,
  pageSize: number,
  searchQuery: string = '',
  providerTypeFilter: string = 'ALL',
  providerStatusFilter: string = 'ALL',
  providerVisibilityFilter: string = 'ALL',
  sortByCreatedLatest: boolean = false
) => {
  try {
    // const dataObj = await paginationRequestCall(pageKey, pageSize, searchQuery, GET_ALL_PROVIDERS_BY_USER_WITH_PAGINATION)
    const accessToken = await getFirebaseIdToken();
    const { data } = await axios.get(GET_ALL_PROVIDERS_BY_USER_WITH_PAGINATION, {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${accessToken}`,
      },
      params: {
        pageKey,
        pageSize,
        searchQuery,
        providerType: providerTypeFilter,
        providerStatus: providerStatusFilter,
        providerVisibility: providerVisibilityFilter,
        sortByCreatedLatest: sortByCreatedLatest,
      },
    });
    if (data.isSuccess) {
      const { providers, count, isSuccess } = data;
      return { providers, count, isSuccess };
    } else {
      return { providers: [], count: 0, isSuccess: false };
    }
  } catch (error) {
    console.log('something went erong, couldnt fetch the provider list,', error);
  }
};

export const getAllExploreProvidersWithPagination = async (
  pageKey: number,
  pageSize: number,
  searchQuery: string = '',
  providerType: string = 'ALL'
) => {
  try {
    const dataObj = await paginationRequestCall(
      pageKey,
      pageSize,
      searchQuery,
      GET_ALL_EXPLORE_PROVIDERS_WITH_PAGINATION,
      providerType
    );
    if (dataObj.isSuccess) {
      return dataObj;
    }
  } catch (error) {
    console.log('something went erong, couldnt fetch the provider list,', error);
  }
};

export const getAllProvidersWithPagination = async (
  pageKey: number,
  pageSize: number,
  searchQuery: string = '',
  providerTypeFilter: string = 'ALL',
  providerStatusFilter: string = 'ALL',
  providerVisibilityFilter: string = 'ALL',
  sortByCreatedLatest: boolean = false
) => {
  try {
    const accessToken = await getFirebaseIdToken();
    const { data } = await axios.get(GET_ALL_PROVIDERS_WITH_PAGINATION, {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${accessToken}`,
      },
      params: {
        pageKey,
        pageSize,
        searchQuery,
        providerType: providerTypeFilter,
        providerStatus: providerStatusFilter,
        providerVisibility: providerVisibilityFilter,
        sortByCreatedLatest: sortByCreatedLatest,
      },
    });
    if (data.isSuccess) {
      const { providers, count, isSuccess } = data;
      return { providers, count, isSuccess };
    } else {
      return { providers: [], count: 0, isSuccess: false };
    }
  } catch (error) {
    console.log('something went erong, couldnt fetch the provider list,', error);
  }
};
